import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import FormInput from '../input/FormInput';
import { useGetRecentPailWeights } from '../../../../main/apps/FunctionalApps/pail-weight/PailWeight.queries';
import { CircularProgress, InputAdornment } from '@mui/material';
import moment from 'moment';

function PailWeightCalculation({ name, dateRef, producerRef, references, constants, ...props }) {
    const {
        setValue,
        getValues,
        watch,
        formState: { dirtyFields },
    } = useFormContext();

    const date = watch(dateRef);
    const producer = watch(producerRef);

    const { data: pailWeight, isLoading } = useGetRecentPailWeights({
        date: moment(date).format('yyyy-MM'),
        producer_id: producer,
        enabled: !!date && !!producer,
    });

    useEffect(() => {
        const calculateValue = () => {
            const [initial, ...values] = getValues([...references]);
            if (pailWeight?.weight != null) values.push(pailWeight.weight);
            else if (constants) values.push(...constants);
            const result = values.reduce((prev, current) => parseFloat(prev) * (parseFloat(current) || 0), initial);
            setValue(name, parseFloat(result.toFixed(1)) || 0, { shouldDirty: true });
        };

        // Recalculate when referenced fields change
        if (references.some((ref) => dirtyFields[ref])) {
            calculateValue();
        }
    }, [...watch([...references]), pailWeight]);

    return (
        <FormInput
            name={name}
            {...props}
            props={{
                ...props.props,
                InputProps: {
                    startAdornment:
                        isLoading && !!date && !!producer ? (
                            <InputAdornment position="start">
                                <CircularProgress size={20} />
                            </InputAdornment>
                        ) : null,
                },
            }}
        />
    );
}

export default PailWeightCalculation;
